import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ContactUs from './ContactUs';
import ClinicMap from './ClinicMap';
import { withTranslation } from 'react-i18next';

class Formulario extends Component {
  componentDidMount() {
    document.title = 'Contacto - Veterinaria Los Cuartos';
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="headerSpace" />
        <h1 className="subheader">{t('formulario.tituloForm')}</h1>
        <p className="form-privacy-intro" role="note">
          {t('formulario.privacyLayer1')}{' '}
          <Link to="/politica-privacidad">{t('formulario.privacyLink')}</Link>.
        </p>
        <div className="center">
          <div id="content">
            <ContactUs />
            <ClinicMap />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation('global')(Formulario);

